
import clsx from 'clsx';
import { ReactElement, ReactNode, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hook';
import { BreadcrumbsIcon } from '../../icons/breadcrumbIcon';
import { CompanyIcon } from '../../icons/companyIcon';
import { DashboardIcon } from '../../icons/dashboardIcon';
import { InvoiceIcon } from '../../icons/invoiceIcon';
import { Logo } from '../../icons/logo';
import MiniLogo from '../../icons/miniLogo';
import { OperatorIcon } from '../../icons/operatorIcon';
import { MenuStatus } from '../../layout/dto';
import { setMenuStatus } from '../../layout/slice';
import { MenuItems } from './dto';
import NavLinks from './nav-links';

const uriMap = new Map<MenuItems, string>([
  [MenuItems.DASHBOARD, '/'],
  [MenuItems.LISTING, '/customer'],
  [MenuItems.USERS, '/users'],
  [MenuItems.INVOICEAMOUNT, '/invoice-amount']
])

const labelMap = new Map<MenuItems, string>([
  [MenuItems.DASHBOARD, 'Dashboard'],
  [MenuItems.LISTING, 'Clienti'],
  [MenuItems.USERS, 'Utenti'],
  [MenuItems.INVOICEAMOUNT, 'Gestioni costi Cloud']
])

const iconMap = new Map<MenuItems, ReactElement>([
  [MenuItems.DASHBOARD, <DashboardIcon size={"20"} color={''} />],
  [MenuItems.LISTING, <CompanyIcon size={'20'} color={''} />],
  [MenuItems.USERS, <OperatorIcon size={'20'} color={''} />],
  [MenuItems.INVOICEAMOUNT, <InvoiceIcon size={'20'} color={''} />],
])

export default function SidebarComponent(props: { menuItem: MenuItems }) {
  const { menuItem } = props

  const dispatch = useAppDispatch()

  const [isHover, setIsHover] = useState<boolean>(false)

  let logo: ReactNode[] = []

  const layoutState = useAppSelector(state => state.layout)

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: 'white', overflow: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}
        className={clsx(
          'h-[64px] lg:h-[80px]',
          {
            'lg:py-[16px] lg:px-[20px] py-[16px] px-[24px] justify-between': layoutState.menuStatus !== MenuStatus.CLOSED,
            'py-[16px] lg:px-[0px] justify-center ': layoutState.menuStatus === MenuStatus.CLOSED,
          }
        )}>
        {layoutState.menuStatus !== MenuStatus.CLOSED && <Logo width={100} />}
        {layoutState.menuStatus === MenuStatus.CLOSED && <MiniLogo />}
        <div
          onClick={() => {
            if (layoutState.menuStatus === MenuStatus.OPEN) {
              dispatch(setMenuStatus(MenuStatus.CLOSED))
            } else if (layoutState.menuStatus === MenuStatus.HOVER) {
              dispatch(setMenuStatus(MenuStatus.OPEN))
            }
          }}
          className={
            clsx(
              'transition-all cursor-pointer hidden',
              {
                'rotate-0 lg:block': layoutState.menuStatus === MenuStatus.OPEN,
                'rotate-180 lg:block': layoutState.menuStatus === MenuStatus.HOVER,
                'hidden': layoutState.menuStatus === MenuStatus.CLOSED
              }
            )
          }>
          <BreadcrumbsIcon />
        </div>
      </div>
      {
        layoutState.menuItems.map((item) => (
          <div key={labelMap.get(item)} className={"flex flex-col items-start justify-start px-4 py-1"}>
            <NavLinks
              menuItem={menuItem}
              link={
                {
                  href: uriMap.get(item),
                  name: labelMap.get(item),
                  icon: iconMap.get(item),
                  menuItem: item
                }
              }
            />
          </div>
        ))
      }
      <div
        style={{ padding: '24px 16px 24px 16px', height: '100%', display: 'flex', justifyContent: 'start', alignItems: 'flex-end' }}
        className='text-label-sm font-medium text-neutral-500 transition-all'
      >
        <span
          className={
            clsx(
              'transition-all',
              {
                "block": layoutState.menuStatus === MenuStatus.CLOSED,
                "hidden content-['© 2024 Fiscalbright']": layoutState.menuStatus !== MenuStatus.CLOSED
              }
            )
          }>
          ©
        </span>
        <div className='flex flex-col gap-6 w-full'>
          <span
            className={
              clsx(
                'transition-all',
                {
                  "hidden": layoutState.menuStatus === MenuStatus.CLOSED,
                  "block": layoutState.menuStatus !== MenuStatus.CLOSED
                }
              )
            }>
            © {new Date().getFullYear()} Billow
          </span>
        </div>
      </div>
    </div>
  );
}
